import { render, staticRenderFns } from "./BarcodeOrderFilters.vue?vue&type=template&id=0d6023d4"
import script from "./BarcodeOrderFilters.vue?vue&type=script&lang=ts"
export * from "./BarcodeOrderFilters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports